<script context="module">
  export let sortedSpecimens
</script>

<script>
  import { SPECIMENS } from '../../data/sections.js'
  import Label from '../label.svelte'
  export let content

  let specimen = true

  function getPath(name) {
    return content.images.find((x) => x.name === name).path
  }

  sortedSpecimens = [
    {
      name: 'ATF',
      column: '3/span 2',
      row: '2/span 2',
      idx: 3,
      path: getPath('ATF'),
    },
    {
      name: 'Nebiolo',
      column: '6/span 4',
      row: '1/span 5',
      idx: 2,
      path: getPath('Nebiolo'),
    },
    {
      name: 'LT03',
      column: '2/span 5',
      row: '3/span 6',
      idx: 1,
      path: getPath('LT03'),
    },
    {
      name: 'SB01',
      column: '5/span 3',
      row: '6/span 4',
      idx: 2,
      path: getPath('SB01'),
    },
    {
      name: 'SB06',
      column: '9/span 2',
      row: '5/span 3',
      idx: 1,
      path: getPath('SB06'),
    },
    {
      name: 'LT01',
      column: '1/span 4',
      row: '9/span 4',
      idx: 3,
      path: getPath('LT01'),
    },
    {
      name: 'SB02',
      column: '4/span 5',
      row: '12/span 3',
      idx: 2,
      path: getPath('SB02'),
    },
    {
      name: 'SB03',
      column: '2/span 4',
      row: '14/span 3',
      idx: 1,
      path: getPath('SB03'),
    },
    {
      name: 'LT02',
      column: '6/span 5',
      row: '15/span 4',
      idx: 3,
      path: getPath('LT02'),
    },
    {
      name: 'SB08',
      column: '2/span 5',
      row: '17/span 4',
      idx: 1,
      path: getPath('SB08'),
    },
    {
      name: 'SB07',
      column: '1/span 4',
      row: '19/span 6',
      idx: 2,
      path: getPath('SB07'),
    },
    {
      name: 'SB09',
      column: '8/span 2',
      row: '20/span 3',
      idx: 4,
      path: getPath('SB09'),
    },
    {
      name: 'FTF',
      column: '4/span 5',
      row: '22/span 5',
      idx: 3,
      path: getPath('FTF'),
    },
    {
      name: 'SB05',
      column: '7/span 4',
      row: '25/span 3',
      idx: 2,
      path: getPath('SB05'),
    },
    {
      name: 'SB04',
      column: '2/span 3',
      row: '26/span 3',
      idx: 4,
      path: getPath('SB04'),
    },
  ]
</script>

<ul>
  {#each sortedSpecimens as specimen}
    <li
      style="
        grid-column:{specimen.column};
        grid-row:{specimen.row};
        z-index:{specimen.idx};">
      <Label img={specimen.path} {specimen} name={specimen.name} />
    </li>
  {/each}
</ul>

<style lang="scss">
  ul {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    grid-template-rows: 1fr 6fr 2fr 11fr 1fr 2fr 4fr 2fr 2fr 2fr 2fr 12fr 2fr 2fr 4fr 7fr 2fr 12fr 1fr 2fr 2fr 2fr 2fr 4fr 4fr 6fr 3fr;
  }
</style>
